._1qyl6mt0 {
  border-radius: 16px;
  outline: 1px solid var(--_1qu8za21);
  outline-offset: -1px;
  display: flex;
  flex-direction: column;
  background-color: var(--_1qu8za2b);
}
._1qyl6mt1 {
  display: flex;
  flex-direction: column;
}
._1qyl6mt2 {
  padding: 12px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex-grow: 1;
  justify-content: space-between;
}
._1qyl6mt3 {
  background-color: var(--_1qu8za2d);
  aspect-ratio: 21 / 9;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  flex-shrink: 0;
}
._1qyl6mt4 {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
._1qyl6mt5 {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 8px;
}
._1qyl6mt6 {
  margin-top: 8px;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.3;
  letter-spacing: -0.02em;
}
._1qyl6mt7 {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
}
._1qyl6mt8 {
  max-width: 100%;
}
._1qyl6mt9:hover {
  text-decoration: underline;
}
._1qyl6mta {
  display: flex;
  gap: 12px;
}
._1qyl6mtb {
  display: grid;
  gap: 8px;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  min-height: 33px;
}
._1qyl6mtc {
  grid-auto-flow: row;
}
._1qyl6mte {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  gap: 4px;
  color: var(--_1qu8za23);
  box-shadow: 0 0 0 1px var(--_1baaexs2k);
  cursor: default;
  width: auto;
}
._1qyl6mte:hover {
  background-color: var(--_9vn8ob4);
}
._1qyl6mtf {
  margin-top: 16px;
  padding-left: 16px;
  padding-right: 16px;
}
._1qyl6mtg {
  display: flex;
  justify-content: center;
  padding-bottom: 16px;
}
._1qyl6mth {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
}
@media screen and (min-width: 768px) {
  ._1qyl6mt0 {
    padding: 32px;
  }
  ._1qyl6mt1 {
    gap: 24px;
    flex-direction: row;
  }
  ._1qyl6mt2 {
    padding: 0;
  }
  ._1qyl6mt3 {
    aspect-ratio: 3 / 2;
    border-radius: 12px;
    width: 47%;
  }
  ._1qyl6mt6 {
    font-weight: 700;
    font-size: 40px;
    line-height: 1.3;
    letter-spacing: 0.01em;
  }
  ._1qyl6mt7 {
    font-weight: 700;
    font-size: 16px;
    line-height: 1.3;
    letter-spacing: -0.02em;
  }
  ._1qyl6mtb {
    grid-auto-columns: max-content;
    justify-content: flex-end;
  }
  ._1qyl6mtc {
    grid-auto-columns: max-content;
  }
  ._1qyl6mtd {
    margin-left: auto;
  }
  ._1qyl6mte {
    width: fit-content;
  }
  ._1qyl6mtf {
    padding: 0;
  }
  ._1qyl6mtg {
    padding-bottom: 0;
  }
  ._1qyl6mth {
    margin-top: 24px;
  }
}
@media screen and (min-width: 1024px) {

}
@media screen and (min-width: 1280px) {
  ._1qyl6mtc {
    grid-auto-flow: column;
    justify-content: space-between;
  }
  ._1qyl6mtd {
    margin-left: unset;
  }
  ._1qyl6mth {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3;
    letter-spacing: -0.01em;
  }
}